import {useState} from "react";
import {Modal, QRCode, Space, Button, message, Tooltip} from "antd";
import {QrCode} from "lucide-react";
import {images} from "../../../constants";

function doDownload(url, fileName) {
    const a = document.createElement("a");
    a.download = fileName;
    a.href = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

const downloadCanvasQRCode = () => {
    const canvas = document.getElementById("myqrcode")?.querySelector("canvas");
    if (canvas) {
        const url = canvas.toDataURL();
        doDownload(url, "QRCode.png");
    }
};

const copyCanvasQRCode = () => {
    const canvas = document.querySelector("#myqrcode canvas");
    if (canvas) {
        canvas.toBlob((blob) => {
            navigator.clipboard
                .write([
                    new ClipboardItem({
                        "image/png": blob,
                    }),
                ])
                .then(() => message.success("QR Code copied to clipboard!"))
                .catch(() => message.error("Failed to copy QR Code"));
        });
    }
};

const QRCodeModal = ({url}) => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => setIsModalVisible(true);
    const handleCancel = () => setIsModalVisible(false);

    return (
        <>
            <Tooltip title="Link as QRCode">
                <QrCode size={24} onClick={showModal} style={{cursor: "pointer"}}/>
            </Tooltip>

            <Modal
                title="QR Code"
                open={isModalVisible}
                footer={null}
                onCancel={handleCancel}
                centered
                width={350}
                bodyStyle={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: 24,
                }}
            >
                <Space id="myqrcode" direction="vertical">
                    <div>
                        <QRCode
                            type="canvas"
                            size={250}
                            style={{marginBottom: 16}}
                            bgColor="#fff"
                            value={url}
                            icon={images.logoFboxNoFrame}
                        />
                        <Button type="primary" onClick={downloadCanvasQRCode}>
                            Download
                        </Button>
                        <Button style={{marginLeft: 8}} onClick={copyCanvasQRCode}>
                            Copy
                        </Button>
                    </div>
                </Space>
            </Modal>
        </>
    );
};

export default QRCodeModal;
